import React, { useEffect, useState, Suspense } from "react";
import { Modal, Form, Input, DatePicker, Select, Row, Col, Button, Spin, Typography, message } from "antd";
import locale from "antd/es/date-picker/locale/es_ES";
import dayjs from "dayjs";
import "dayjs/locale/es";
import PhoneInput from "react-phone-input-2";
import Puestos from "../puestos/Puestos";

dayjs.locale("es");
const { Title } = Typography;

const EditarEmpleadoModal = ({ visible, onClose, empleado, onSave, loading, sucursal }) => {
  const [form] = Form.useForm();
  const [gender, setGender] = useState(empleado?.genero || "");
  const [customGender, setCustomGender] = useState(empleado?.otro_genero || "");
  const [puesto, setPuesto] = useState(empleado?.puesto || null);
  const [areas, setAreas] = useState(empleado?.areas || []);
  const [areasOptions, setAreasOptions] = useState([]);
  const [additionalValues, setAdditionalValues] = useState(empleado?.areas || []);

  useEffect(() => {
    if (empleado) {
      setGender(empleado.genero || "");
      setCustomGender(empleado.otro_genero || "");
      setPuesto(empleado.puesto || null);
      setAreas(empleado.areas || []);
      setAdditionalValues(empleado.areas || []);
      form.setFieldsValue({
        ...empleado,
        fecha_nacimiento: empleado.fecha_nacimiento ? dayjs(empleado.fecha_nacimiento) : null,
        fecha_ingreso: empleado.fecha_ingreso ? dayjs(empleado.fecha_ingreso) : null,
      });
    }
  }, [empleado, form]);

  const handleGenderChange = (value) => {
    setGender(value);
    if (value !== "Otro") setCustomGender("");
  };

  const handleCustomGenderChange = (e) => setCustomGender(e.target.value);

  const puestoChange = (value, areasList) => {
    setPuesto(value);
    setAreasOptions(areasList);
    setAdditionalValues([]);
    form.setFieldsValue({ areas: [] });
  };

  const handleFinish = (values) => {
    const uid = empleado?.id || empleado?.uid;
    if (!uid) {
      message.error("No se pudo identificar el empleado a editar.");
      return;
    }
    onSave({
      ...empleado,
      ...values,
      puesto,
      areas: additionalValues,
      genero: gender,
      otro_genero: gender === "Otro" ? customGender : undefined,
      fecha_nacimiento: values.fecha_nacimiento ? values.fecha_nacimiento.format("YYYY-MM-DD") : undefined,
      fecha_ingreso: values.fecha_ingreso ? values.fecha_ingreso.format("YYYY-MM-DD") : undefined,
      sucursal,
      uid,
    });
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      title={<Title level={4} style={{ margin: 0, color: '#2b3a55' }}>Editar Empleado</Title>}
      footer={null}
      width={700}
      style={{ top: 40 }}
      bodyStyle={{ background: '#f7f9fb', borderRadius: 12 }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        style={{ marginTop: 16 }}
      >
        <Row gutter={24}>
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              id="nombre"
              label="Nombre(s)"
              name="nombre"
              rules={[{ required: true, message: "Por favor ingrese su(s) nombre(s)" }]}
            >
              <Input placeholder="Ingrese su(s) nombre(s)" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              id="ap_paterno"
              label="Apellido Paterno"
              name="ap_paterno"
              rules={[{ required: true, message: "Por favor ingrese su apellido paterno" }]}
            >
              <Input placeholder="Ingrese su apellido paterno" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              id="ap_materno"
              label="Apellido Materno"
              name="ap_materno"
              rules={[{ required: true, message: "Por favor ingrese su apellido materno" }]}
            >
              <Input placeholder="Ingrese su apellido materno" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              id="domicilio"
              label="Domicilio"
              name="domicilio"
            >
              <Input placeholder="Ingrese su domicilio del empleado" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              id="fecha_nacimiento"
              label="Fecha de Nacimiento"
              name="fecha_nacimiento"
              rules={[{ required: true, message: "Por favor seleccione su fecha de nacimiento" }]}
            >
              <DatePicker
                format="YYYY-MM-DD"
                locale={locale}
                style={{ width: "100%" }}
                placeholder="Seleccione su fecha de nacimiento"
                picker="date"
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              id="fecha_ingreso"
              label="Fecha de Ingreso"
              name="fecha_ingreso"
              rules={[{ required: true, message: "Por favor seleccione su fecha de ingreso" }]}
            >
              <DatePicker
                format="YYYY-MM-DD"
                locale={locale}
                style={{ width: "100%" }}
                placeholder="Seleccione su fecha de ingreso"
                picker="date"
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              id="celular"
              label="Celular"
              name="celular"
              rules={[
                { required: false },
                { pattern: /^[0-9]{12}$/, message: "Ingrese un número de teléfono válido (10 dígitos)" },
              ]}
            >
              <PhoneInput className="number" country={"mx"} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <Form.Item
              id="genero"
              label="Género"
              name="genero"
              rules={[{ required: true, message: "Por favor seleccione su género" }]}
            >
              <Select value={gender} onChange={handleGenderChange} placeholder="Seleccione su género">
                <Select.Option value="Hombre">Hombre</Select.Option>
                <Select.Option value="Mujer">Mujer</Select.Option>
                <Select.Option value="Otro">Otro</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          {gender === "Otro" && (
            <Col xs={24} md={12} lg={8}>
              <Form.Item
                id="otro_genero"
                label="Especifique su género"
                name="otro_genero"
                rules={[{ required: true, message: "Por favor ingrese su género" }]}
              >
                <Input value={customGender} onChange={handleCustomGenderChange} placeholder="Ingrese su género" />
              </Form.Item>
            </Col>
          )}

          <Col xs={24} md={12} lg={8}>
            <Puestos onPuestoChange={puestoChange} sucursal={sucursal} value={puesto} />
          </Col>
          {puesto && areasOptions.length > 0 && (
            <Col xs={24} md={12} lg={8}>
              <Form.Item
                id="areas"
                label="Área de trabajo"
                name="areas"
                rules={[{ required: true, message: "Por favor seleccione las áreas de trabajo" }]}
              >
                <Select
                  mode="multiple"
                  value={additionalValues}
                  onChange={setAdditionalValues}
                  placeholder="Seleccione las áreas"
                >
                  {areasOptions.map((area) => (
                    <Select.Option key={area.nombre} value={area.nombre}>
                      {area.nombre}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
        </Row>
        <div style={{ marginTop: 32, textAlign: "right" }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>Cancelar</Button>
          <Button type="primary" htmlType="submit" loading={loading} size="large">
            Guardar Cambios
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default EditarEmpleadoModal;
